var mymap = L.map('mapid').setView([45.7032695, 3.344853599999965], 5);
var popup = L.popup();
var marker = L.marker();

// var geocoder = L.Control.geocoder({
//     defaultMarkGeocode: false,
//     placeholder: 'Rechercher',
//     errorMessage: 'Aucun résultat.',
//     position: 'bottomright'
// }).on('markgeocode', function(e) {
//     var bbox = e.geocode.bbox;
//     var poly = L.polygon([
//         bbox.getSouthEast(),
//         bbox.getNorthEast(),
//         bbox.getNorthWest(),
//         bbox.getSouthWest()
//     ]);
//     mymap.fitBounds(poly.getBounds());
// }).addTo(mymap);

var topoTiles = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
    maxZoom: 19
}).addTo(mymap);

var EsriWorldImagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
});

var baseMaps = {
    "Fond cartographique": topoTiles,
    "Satellite": EsriWorldImagery
};

var overlayMaps = {};

L.control.layers(baseMaps, overlayMaps, {position: 'bottomright'}).addTo(mymap);